import { render, staticRenderFns } from "./EnrolmentView.vue?vue&type=template&id=0a4dec58&scoped=true&"
import script from "./EnrolmentView.vue?vue&type=script&lang=js&"
export * from "./EnrolmentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4dec58",
  null
  
)

export default component.exports